<template>
    <div :class="'latest-activity recent-activity ' + role">
        <h2>Recent Activity:</h2>
        <div class="latest-activity-inner" v-if="newNotificationsCount">
            <div v-bind:key="index" v-for="(item, index) in newNotifications" class="notification-item">
              <a :aria-label="item.ariaLabel" :href="item.linkUrl" class="md-list-item-link"><span v-html="item.ariaLabel"></span><md-icon>arrow_right_alt</md-icon></a>
            </div>
        </div>
        <div class="latest-activity-inner" v-else>
            No new activity. You’re all caught up!
        </div>
        <md-button @click="$emit('notification-toggle')" class="button-notification-count">View all</md-button>
    </div>
</template>

<script>
  export default {
    name: "RecentActivity",
    computed: {

      role() {
        return drupalSettings.user.role
      }

    },
    data() {
      return {
        newNotifications: [],
        newNotificationsCount: window.drupalSettings.notifications ? window.drupalSettings.notifications.newCount : 0,
      };
    },
    mounted() {
      if (window.drupalSettings.notifications.items) {
        window.drupalSettings.notifications.items.forEach(item => {
          if (item.isNew && this.newNotifications.length < 3) {
            this.newNotifications.push(item);
          }
        });
      }
    }
  };
</script>
